module.exports = __webpack_public_path__ + "img/kakugyo.7462a54f.png";